import apiInstance from "./axiosBase";

export const CalendarAPI = {
  download: (formData) => {
    return apiInstance.post(`/calendar/events`, formData, {
      responseType: "blob",
    });
  },
};
